import React from 'react';
import { Box, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

interface BackButtonProps {
  onClick: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ onClick }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
      }}
      onClick={onClick}
    >
      <ChevronLeftIcon></ChevronLeftIcon>
      <Typography>Back</Typography>
    </Box>
  );
};

export default BackButton;
